module.exports = __webpack_public_path__ + "static/swap-shifts-3fe3ba1c7e930689ba8e76f9a658453d.png";